<template>
  <div class="flex items-center" aria-haspopup="true" aria-controls="overlay_menu" @mouseenter="menuRef.toggle($event)">
    <DAvatarGroup>
      <DAvatar
        :label="initials()"
        :image="userStore.user?.photo_url"
        shape="circle"
        class="h-8 w-8"
        :class="currentUsers?.length > 1 ? 'mr-2' : ''" />
      <template v-for="user in currentUsers || []">
        <DAvatar
          v-if="user.id !== userStore.user.id"
          :class="user.id === userStore.followingUser ? 'border border-fuchsia-500' : ''"
          :key="user.id"
          :image="user?.photo_url"
          shape="circle"
          class="h-6 w-6"
          @click="() => followUser(user)" />
      </template>
    </DAvatarGroup>
    <DMenu
      :model="menuItems"
      :popup="true"
      id="overlay_menu"
      ref="menuRef"
      class="max-w-20"
      @mouseleave="menuRef.toggle($event)">
      <template #start>
        <div
          class="mx-2 my-2 flex items-center gap-2 overflow-hidden border-b border-gray-800 pb-2 text-base font-semibold text-gray-400">
          <User size="16" />
          <span class="inline-flex truncate">{{ userStore.user?.first_name }} {{ userStore.user?.last_name }}</span>
        </div>
      </template>
      <template #item="{ item, props }">
        <div class="flex cursor-pointer items-center gap-2 px-2 py-2" @click="item.command">
          <component v-if="item.icon && typeof item.icon === 'function'" :is="item.icon" size="16" />
          <i v-else :class="item.icon"></i>
          <span class="font-medium tracking-wide">{{ item.label }}</span>
        </div>
      </template>
    </DMenu>
  </div>
</template>

<script setup>
import { useUserStore } from '@/stores/userStore';
import { DAvatar, DAvatarGroup, DMenu } from '@disguise/cloud-ui';
import { LogOut, User } from 'lucide-vue-next';
import { ref, toRefs } from 'vue';

const props = defineProps({
  currentUsers: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['logout']);

const { currentUsers } = toRefs(props);

const userStore = useUserStore();

const menuRef = ref(null);
const menuItems = [
  {
    label: 'Logout',
    icon: LogOut,
    command: () => {
      emit('logout');
    },
  },
];

const initials = () => {
  const user = userStore.user;
  const firstInitial = user?.first_name ? user.first_name.charAt(0).toUpperCase() : '';
  const lastInitial = user?.last_name ? user.last_name.charAt(0).toUpperCase() : '';
  return firstInitial + lastInitial;
};

const followUser = (user) => {
  useUserStore.followUser(user);
};
</script>
